import { getDefaultStore } from "jotai";
import { isPersistenceEnabled } from "../../utils/environment";
import { colors } from "../../utils/style";
import { hasDirtyAtom, isOnlineAtom, syncStateAtom } from "../atoms";

const SyncStatuses = {
  ok: { id: "ok", message: "Everything is synced", color: colors.bg.ok },
  booting: { id: "booting", message: "Booting...", color: colors.bg.tertiary },
  offline: {
    id: "offline",
    message: "You are offline",
    color: colors.bg.offline,
  },
  disabled: {
    id: "disabled",
    message: "Persistence is disabled",
    color: colors.bg.warning,
  },
  warning: { id: "warning", message: "Syncing...", color: colors.bg.warning },
  error: {
    id: "error",
    message: "There's an issue with syncing",
    color: colors.bg.error,
  },
} as const;
type SyncStatus = (typeof SyncStatuses)[keyof typeof SyncStatuses];

export function computeSyncStatus(): SyncStatus {
  const syncState = getDefaultStore().get(syncStateAtom);
  const isOnline = getDefaultStore().get(isOnlineAtom);
  const now = Date.now();
  const hasDirty = getDefaultStore().get(hasDirtyAtom);

  if (!isPersistenceEnabled) {
    return SyncStatuses.disabled;
  }

  if (now - syncState.startTime < 1_000) {
    return SyncStatuses.booting;
  }

  if (!isOnline) {
    return SyncStatuses.offline;
  }

  if (syncState.pendingUpdateCount > 4 && syncState.appNoteCount >= syncState.serverNoteCount) {
    return SyncStatuses.error;
  }

  if (syncState.pendingUpdateCount > 0 || syncState.appNoteCount !== syncState.serverNoteCount || hasDirty) {
    return SyncStatuses.warning;
  }

  return SyncStatuses.ok;
}
